<ui-breadcrumb-nav ariaLabel="Breadcrumb">
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organization().id]">
      {{ organization().name }}
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organization().id, 'settings']">
      {{ 'cockpit.nav.settings' | transloco }}
    </a>
  </ui-breadcrumb>
</ui-breadcrumb-nav>
